import ProficiencyBonusBox from "./ProficiencyBonusBox";

export default ProficiencyBonusBox;
export { ProficiencyBonusBox };
